// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
// Models
import { CustomerModel } from '../../_models/customer.model';

import { environment } from 'src/environments/environment';
import HttpContextTokens from 'src/app/_intercepters/http-context-tokens';

const API_CUSTOMERS_URL = environment.baseUrl + '/customers';

const HTTP_CONTEXT = new HttpContext().set(HttpContextTokens.ERROR_REASON_PREFIX, "PRODUCTS.MESSAGES.ERRORS");

@Injectable()
export class CustomersService {
	constructor(private http: HttpClient) { }

	getAll(page: number = 1, pageSize: number = 20, sortField: string = undefined,
		sort: string = undefined, filters: any = undefined): Observable<any> {
		let params: any = { page, pageSize };
		if (sortField)
			params.sortField = sortField;
		if (sort)
			params.sort = sort;
		if (filters)
			params.filters = JSON.stringify(filters);
		return this.http.get<any>(API_CUSTOMERS_URL, { params, context: HTTP_CONTEXT });
	}

	getAllCustomers() {
		return this.http.get<any>(`${API_CUSTOMERS_URL}/all`, { context: HTTP_CONTEXT });
	}

	getById(id: number): Observable<CustomerModel> {
		return this.http.get<CustomerModel>(`${API_CUSTOMERS_URL}/${id}`, { context: HTTP_CONTEXT });
	}

	create(customer: CustomerModel): Observable<any> {
		return this.http.post<CustomerModel>(API_CUSTOMERS_URL, customer, { context: HTTP_CONTEXT });
	}

	update(customer: CustomerModel): Observable<any> {
		return this.http.put(API_CUSTOMERS_URL, customer, { context: HTTP_CONTEXT });
	}

	delete(id: number) {
		return this.http.delete(`${API_CUSTOMERS_URL}/${id}`, { context: HTTP_CONTEXT });
	}
}